var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:_vm.customClasses},[(_vm.color)?_c('span',{staticClass:"badge__color"}):_vm._e(),(_vm.colorHex)?_c('span',{staticClass:"badge__color",style:({'background-color': _vm.colorHex})}):_vm._e(),(_vm.showText)?_c('div',{staticClass:"badge__text"},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }